<div #overlay class="overlay">
  <div class="content center-content">
    <ng-container *ngIf="data?.hasPreviousVersion; else firstVersionDelete">
      <div class="column-flex">
        <mat-icon svgIcon="delete" class="icon" data-cy="version-delete-version-icon" />
        <div class="title">
          {{ 'version.delete.dialog.title' | translate }}
        </div>
        <div class="subtitle">
          {{ 'version.delete.dialog.subtitle' | translate }}
        </div>

        <div class="buttons-container">
          <div class="button" data-cy="version-delete-version-cancel-button" (click)="cancel()">
            {{ 'version.delete.dialog.button.cancel' | translate }}
          </div>
          <div class="button delete" (click)="deleteVersion()">
            {{ 'version.delete.dialog.button.confirm' | translate }}
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #firstVersionDelete>
      <div class="column-flex first-version-wrapper">
        <div class="first-version-container">
          <div class="title bold" data-cy="version-delete-first-version-modal-header">
            {{ 'first-version.delete.dialog.title' | translate }}
          </div>
          <div class="subtitle">
            {{ 'first-version.delete.dialog.subtitle-1' | translate }}
            <br /><br />
            {{ 'first-version.delete.dialog.subtitle-2' | translate }}
            <br /><br />
            {{ 'first-version.delete.dialog.subtitle-3' | translate }}
          </div>
          <div class="vessel-data-container">
            <form class="input-form">
              <app-channel-text-input
                #inputElement
                [value]="vesselNumber"
                [label]="'vessel.create.dialog.form.number'"
                [name]="NUMBER"
                [inputError]="validationErrors?.number"
                [isDisabled]="true"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [maxLength]="16"></app-channel-text-input>
            </form>
            <form class="input-form">
              <app-channel-text-input
                #inputElement
                [value]="vesselName"
                [label]="'vessel.create.dialog.form.name'"
                [name]="NAME"
                [inputError]="validationErrors?.name"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [maxLength]="16"></app-channel-text-input>
            </form>
            <form class="input-form">
              <app-channel-text-input
                #inputElement
                [value]="drawingId"
                [label]="'vessel.create.dialog.form.drawingId'"
                [name]="DRAWING_ID"
                [inputError]="validationErrors?.drawingId"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [maxLength]="16"></app-channel-text-input>
            </form>
            <div class="row-container">
              <form class="input-form">
                <app-channel-text-input
                  #inputElement
                  type="text"
                  [value]="numberOps"
                  [label]="'vessel.create.dialog.form.ops'"
                  [name]="NUMBER_OF_OPS"
                  [inputError]="validationErrors?.numberOps"
                  (onInputChange)="onInputChange($event)"
                  (onFocusChange)="onInputChange($event)"
                  [maxLength]="2"></app-channel-text-input>
              </form>
              <form class="input-form">
                <app-channel-text-input
                  #inputElement
                  type="text"
                  [value]="numberFcu"
                  [label]="'vessel.create.dialog.form.fcu'"
                  [name]="NUMBER_OF_FCU"
                  [inputError]="validationErrors?.numberFcu"
                  (onInputChange)="onInputChange($event)"
                  (onFocusChange)="onInputChange($event)"
                  [maxLength]="2"></app-channel-text-input>
              </form>
            </div>
          </div>
        </div>
        <div class="first-version-button">
          <div
            class="button"
            data-cy="version-delete-first-version-cancel-button"
            (click)="cancel()">
            {{ 'version.delete.dialog.button.cancel' | translate }}
          </div>
          <div
            class="button delete"
            (click)="deleteVersion()"
            [ngClass]="{ button_disabled: isCreateDisabled() }">
            {{ 'first-version.delete.dialog.button.confirm' | translate }}
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
